@if (components$ | async; as components) {
  <cx-tab [tabs]="tabs$ | async" [config]="tabConfig$ | async">
    @for (component of components; track component; let i = $index) {
      <ng-template
        [cxOutlet]="component.flexType"
        #tabRef
        >
        <ng-container
          [cxComponentWrapper]="component"
          (cxComponentRef)="tabCompLoaded($event, component.uid)"
        ></ng-container>
      </ng-template>
    }
  </cx-tab>
}
